import { useRef, useLayoutEffect } from 'react';
import {
  useAnimalsConversionAcknowledgmentQuery,
  useGetIncompleteAnimalsQuery,
} from 'redux/apiSlice/animal.slice';
import { RoutesPaths } from 'routes/Routes.types';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from 'redux/store';
import appSlice from 'redux/slices/app.slice';
import CompleteAnimalBar from './CompleteAnimalBar';
import ConvertedToPetNotification from './ConvertedToPetNotification';

const Notifications = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const ref = useRef<HTMLDivElement>(null);
  const { data: incompleteAnimals } = useGetIncompleteAnimalsQuery();
  const { data: animalConversionAcknowledgmentData } =
    useAnimalsConversionAcknowledgmentQuery();

  const hideNotification = location.pathname.includes(
    RoutesPaths.KNOWLEDGE_BASE,
  );

  const hideNotificationBanner = location.pathname.includes(
    'application-complete',
  );

  useLayoutEffect(() => {
    if (!ref.current) {
      dispatch(appSlice.actions.setNotificationHeight(0));
      return;
    }

    dispatch(appSlice.actions.setNotificationHeight(ref.current.offsetHeight));
    const resizeObserver = new ResizeObserver(([entry]) => {
      const { height } = entry.contentRect;
      dispatch(appSlice.actions.setNotificationHeight(height));
    });

    resizeObserver.observe(ref.current);

    return () => resizeObserver.disconnect();
  }, [
    dispatch,
    hideNotification,
    hideNotificationBanner,
    incompleteAnimals,
    animalConversionAcknowledgmentData,
  ]);

  if (
    hideNotification ||
    !incompleteAnimals ||
    !animalConversionAcknowledgmentData
  ) {
    return null;
  }
  const animalConversionsToNotify = animalConversionAcknowledgmentData.slice(
    0,
    2,
  );

  const borderedNotificationItems = [];

  if (animalConversionsToNotify.length > 0) {
    if (incompleteAnimals.count > 0) {
      borderedNotificationItems.push(
        animalConversionsToNotify[0].id,
        ...(animalConversionsToNotify.length > 1
          ? [animalConversionsToNotify[1].id]
          : []),
      );
    } else if (animalConversionsToNotify.length === 2) {
      borderedNotificationItems.push(animalConversionsToNotify[0].id);
    }
  }

  return (
    <div ref={ref}>
      {!hideNotificationBanner && (
        <>
          <CompleteAnimalBar data={incompleteAnimals} />
          <ConvertedToPetNotification
            borderedNotificationItems={borderedNotificationItems}
            data={animalConversionsToNotify}
          />
        </>
      )}
    </div>
  );
};

export default Notifications;
